import React, { createContext, useContext, useEffect, useState } from 'react';
import { useGetAllCourseListMutation, useGetAssignmentFoldersMutation } from '../../features/authentication/authApiSlice';
import PropTypes from 'prop-types';

const ExamAndAssignmentsContext = createContext();

export const DataProvider = ({ children }) => {
  const [courseData, setCourseData] = useState([]);
  const [folderData, setFolderData] = useState([]);
  const [getAllCourses] = useGetAllCourseListMutation();
  const [getAllFolders] = useGetAssignmentFoldersMutation();
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    const fetchCourseData = async () => {
      if (!isDataLoaded) {
        try {
          setCourseData(await getAllCourses().unwrap());
          setFolderData(await getAllFolders().unwrap());
          setIsDataLoaded(true);
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchCourseData();
  }, []);

  return (
    <ExamAndAssignmentsContext.Provider value={{ courseData, folderData }}>
      {children}
    </ExamAndAssignmentsContext.Provider>
  );
};

DataProvider.propTypes = {
  children: PropTypes.object
};

export const useData = () => {
  return useContext(ExamAndAssignmentsContext);
};
